import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import role from "./modules/role-module";
import division from "./modules/division-module";
import model_app from "./modules/model_app-module";
import role_permission from "./modules/role_permission-module";
import notification from "./modules/notification-module";

import workshop_service_categories from "./modules/workshop/service_categories-module";
import workshop_service_master from "./modules/workshop/service_master-module";
import workshop_client_master from "./modules/workshop/client_master-module";
import workshop_faktur from "./modules/workshop/faktur-module";
import workshop_part_dealer from "./modules/workshop/part_dealer-module";
import workshop_pkb from "./modules/workshop/pkb-module";
import workshop_procurement_order from "./modules/workshop/procurement_order-module";
import workshop_service_estimate from "./modules/workshop/service_estimate-module";
import workshop_spare_part_master from "./modules/workshop/spare_part_master-module";
import workshop_spare_part_request from "./modules/workshop/spare_part_request-module";
import workshop_spare_part_threshold from "./modules/workshop/spare_part_threshold-module";
import workshop_nota_part from "./modules/workshop/nota_part-module";
import workshop_nota_jasa_bkl from "./modules/workshop/nota_jasa_bkl-module";
import workshop_vehicle_brand from "./modules/workshop/vehicle_brand-module";
import workshop_vehicle_type from "./modules/workshop/vehicle_type-module";
import workshop_vehicle from "./modules/workshop/vehicle-module";
import workshop_spare_part_price from "./modules/workshop/spare_part_price-module";
import workshop_dashboard from "./modules/workshop/dashboard-module";
import workshop_business_unit from "./modules/workshop/business_unit-module";
import workshop_daily_closing from "./modules/workshop/daily_closing-module";
import workshop_checker from "./modules/workshop/checker-module";
import workshop_parking from "./modules/workshop/parking-module";
import workshop_parking_line from "./modules/workshop/parking_line-module";
import workshop_gate_pass from "./modules/workshop/gate_pass-module";
import workshop_spare_part_transfer from "./modules/workshop/spare_part_transfer-module";
import workshop_pool from "./modules/workshop/pool-module";
import workshop_warehouse from "./modules/workshop/warehouse-module";
import fms_cashier from "./modules/fms/cashier-module";
import fms_city from "./modules/fms/city-module";
import fms_dashboard from "./modules/fms/dashboard-module";
import fms_driver_additional_fee from "./modules/fms/driver_additional_fee-module";
import fms_driver_dp from "./modules/fms/driver_dp-module";
import fms_driver from "./modules/fms/driver-module";
import fms_payment_plan from "./modules/fms/payment_plan-module";
import fms_pko from "./modules/fms/pko-module";
import fms_spj from "./modules/fms/spj-module";
import fms_vehicle_brand from "./modules/fms/vehicle_brand-module";
import fms_vehicle_type from "./modules/fms/vehicle_type-module";
import fms_vehicle from "./modules/fms/vehicle-module";
import fms_vehicle_ownership from "./modules/fms/vehicle_ownership-module";
import fms_business_unit from "./modules/fms/business_unit-module";
import fms_dp_amount from "./modules/fms/dp_amount-module";

import finance_click from "./modules/finance/click/click-module";
import finance_click_b2b from "./modules/finance/click/click-b2b-module";



Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    alerts,
    profile,
    users,
    role,
    division,
    model_app,
    role_permission,
    notification,
    workshop_service_categories,
    workshop_service_master,
    workshop_client_master,
    workshop_faktur,
    workshop_part_dealer,
    workshop_pkb,
    workshop_procurement_order,
    workshop_service_estimate,
    workshop_spare_part_master,
    workshop_spare_part_request,
    workshop_spare_part_price,
    workshop_spare_part_threshold,
    workshop_nota_jasa_bkl,
    workshop_nota_part,
    workshop_vehicle_brand,
    workshop_vehicle_type,
    workshop_vehicle,
    workshop_business_unit,
    workshop_daily_closing,
    workshop_checker,
    workshop_parking,
    workshop_parking_line,
    workshop_dashboard,
    workshop_gate_pass,
    workshop_spare_part_transfer,
    workshop_pool,
    workshop_warehouse,
    fms_cashier,
    fms_city,
    fms_dashboard,
    fms_driver_additional_fee,
    fms_driver_dp,
    fms_driver,
    fms_payment_plan,
    fms_pko,
    fms_spj,
    fms_vehicle,
    fms_vehicle_brand,
    fms_vehicle_type,
    fms_vehicle_ownership,
    fms_business_unit,
    fms_dp_amount,
    finance_click,
    finance_click_b2b,
  },
});
